"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Breakpoints = void 0;
var Breakpoints = {
  xxs: "382px",
  xs: "400px",
  s: "600px",
  m: "767px",
  l: "993px",
  xl: "1000px",
  xxl: "1400px",
  xsMUI: "400px",
  smMUI: "600px",
  mMUI: "767px",
  mdMUI: "960px",
  lMUI: "993px",
  lgMUI: "1280px",
  xlMUI: "1000px",
  xxlMUI: "1500px"
};
exports.Breakpoints = Breakpoints;
var _default = Breakpoints;
exports.default = _default;